/**
 * Quantis Voice for the web app: the shared call state on the browser engine,
 * plus the ringing and live-call card, mounted once for the signed-in session.
 * The engine is only created once the server says this workspace's line is connected,
 * so no one else ever loads the calling SDK or asks for the microphone.
 */
import React from 'react';
import { createVoiceApi } from '../../services/VoiceService';
import { API_BASE, getAuthHeaders } from '../../utils/supabase/client';
import { VoiceProvider } from '../../shared-ui/voice/VoiceContext';
import { VoiceCallOverlay } from '../../shared-ui/voice/VoiceCallOverlay';
import type { VoiceEngine } from '../../shared-ui/voice/voiceEngine';
import { createBrowserVoiceEngine } from './browserVoiceEngine';

export function WebVoiceProvider({ children }: { children: React.ReactNode }) {
  const api = React.useMemo(() => createVoiceApi({ apiBase: API_BASE, authHeaders: getAuthHeaders }), []);
  const [engine, setEngine] = React.useState<VoiceEngine | null>(null);
  React.useEffect(() => {
    let cancelled = false;
    api.config().then((config) => { if (!cancelled && config.enabled && config.connected) setEngine(createBrowserVoiceEngine()); }, () => {});
    return () => { cancelled = true; };
  }, [api]);
  return (
    <VoiceProvider api={api} engine={engine}>
      {children}
      <VoiceCallOverlay />
    </VoiceProvider>
  );
}
